import { type AxiosInstance } from 'axios';
import type { BrandTab } from '../types/entity-tabs.js';
import { GetBrandTabsResponseSchema } from '../types/entity-tabs.js';
import type { GetBrands } from './interfaces/workspace.brand.js';
import type * as WS from './interfaces/workspace.brand.js';
import { transformDates } from './transformers/index.js';

export class WorkspaceBrandsClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getBrands = (data: GetBrands.Request) => {
    return this.authenticatedClient.get<GetBrands.Response>(`/workspaces/brands`, { params: data, transformResponse: transformDates });
  };

  /** Creates a brand at the root of the caller's group workspace. Requires `ie:brand:create`. */
  createBrand = (data: WS.CreateBrand.Request) => {
    return this.authenticatedClient.post<WS.CreateBrand.Response>(`/workspaces/brands`, data)
      .then(res => res.data);
  };

  getBrand = (data: WS.GetBrand.Request): Promise<WS.GetBrand.Response> => {
    return this.authenticatedClient.get(`/workspaces/brands/${data.brandId}`, {
      transformResponse: transformDates,
    })
      .then(({ data }) => data);
  };

  /** The tabs the caller may see on the brand, in order (built by chat-api from the caller's actions and access). */
  getBrandTabs = (brandId: number): Promise<BrandTab[]> => {
    return this.authenticatedClient
      .get<unknown>(`/workspaces/brands/${brandId}/tabs`)
      .then(res => GetBrandTabsResponseSchema.parse(res.data).tabs);
  };

  getProjects = (data: WS.GetProjects.Request) => {
    const { brandId, ...params } = data;

    return this.authenticatedClient.get(`/workspaces/brands/${data.brandId}/projects`, {
      params,
    })
      .then(({ data }) => data)
      .then((res: WS.GetProjects.Response<string>) => ({
        items: res.items.map<WS.GetProjects.ProjectItem>(x =>
          /* eslint-disable @typescript-eslint/ban-ts-comment */
          //@ts-ignore
          xform.normalizeProjectDates(x),
        ),
        pagination: res.pagination,
      }));
  };

  getProjectTracker = (data: WS.GetProjectTracker.Request): Promise<WS.GetProjectTracker.Response> => {
    return this.authenticatedClient.get(`/workspaces/brands/${data.brandId}/project-tracker`, {
      transformResponse: transformDates,
    })
      .then(({ data }) => data);
  };
}